import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import classnames from 'classnames';
import { ContentSpacing, breakpoint } from '@estee/elc-base-theme';
import { Subtitle1 } from '@estee/elc-typography';
import { ProductPriceTheme } from '../../../theme/default-theme';
import { PRODUCT_PRICE_RANGE } from '../../constants/DataTestIdAttributes';
import { IPriceRangeData } from '../../domain/entities/Price';
import { ProductPriceRangeDiscount } from '../product-price/ProductPriceRangeDiscount';

export interface IProductPriceRangeRowWrapper {
    className?: string;
}

export interface IProductPriceRangeRow extends IProductPriceRangeRowWrapper {
    priceRange: IPriceRangeData;
    priceRangeNotDiscounted: IPriceRangeData | null;
    isDiscounted: boolean;
    isDiscountedPriceRangeEnabled: boolean;
    formattedOriginalPrice: string | null;
    formattedPrice: string | null;
}

const ProductPriceRangeRowWrapper = styled.div`
    margin: ${ContentSpacing.space16} 0;
    ${breakpoint('desktop')`
        margin: 0;
    `};
`;

const ProductPriceRange = styled(Subtitle1)`
    ${ProductPriceTheme};
`;

const ProductPriceRangeNotDiscounted = styled(Subtitle1)`
    ${ProductPriceTheme};
`;

export const ProductPriceRangeRow = observer(function ProductPriceRangeRow(
    props: IProductPriceRangeRow
) {
    const productPriceRangeRowWrapperClassNames = classnames(
        'elc-product-price-range-row-wrapper',
        'js-product-price-range-row-wrapper'
    );

    const productPriceRangeClassNames = classnames(
        'elc-product-price-range',
        'js-product-price-range'
    );

    const productPriceRangeNotDiscountedClassNames = classnames(
        'elc-product-price-range-not-discounted',
        'js-product-price-range-not-discounted'
    );

    const {
        priceRange,
        priceRangeNotDiscounted,
        isDiscounted,
        formattedOriginalPrice,
        formattedPrice,
        isDiscountedPriceRangeEnabled
    } = props;
    const { formattedMinPrice, formattedMaxPrice, maxDiscountPercent } = priceRange;

    return (
        <ProductPriceRangeRowWrapper
            className={productPriceRangeRowWrapperClassNames}
            data-test-id={PRODUCT_PRICE_RANGE}
            data-price={formattedOriginalPrice}
            data-formatted-price={formattedPrice}
        >
            {isDiscounted && isDiscountedPriceRangeEnabled && priceRangeNotDiscounted && (
                <ProductPriceRangeNotDiscounted
                    className={productPriceRangeNotDiscountedClassNames}
                >
                    {priceRangeNotDiscounted.formattedMinPrice} -{' '}
                    {priceRangeNotDiscounted.formattedMaxPrice}
                </ProductPriceRangeNotDiscounted>
            )}
            <ProductPriceRange className={productPriceRangeClassNames}>
                {formattedMinPrice} - {formattedMaxPrice}
                {!!maxDiscountPercent && (
                    <ProductPriceRangeDiscount maxDiscountPercent={maxDiscountPercent} />
                )}
            </ProductPriceRange>
        </ProductPriceRangeRowWrapper>
    );
});
